module.exports = __webpack_public_path__ + "media/svg-new/icon-doubt-59ad618d.svg";